import { render } from "./TextField.vue?vue&type=template&id=5f4b9e20&scoped=true&ts=true"
import script from "./TextField.vue?vue&type=script&lang=ts"
export * from "./TextField.vue?vue&type=script&lang=ts"

import "./TextField.vue?vue&type=style&index=0&id=5f4b9e20&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4b9e20"]])

export default __exports__